import clsx from 'clsx';
import type { CSSProperties } from 'react';
import Image from 'next/image';

export type HeroOverlayCardProps = {
    title: string;
    subtitle: string;
    iconSrc: string;
    iconAlt?: string;
    /** Width and layout (e.g. `w-[320px] max-w-full shrink-0` or `className` + `style`) */
    className?: string;
    style?: CSSProperties;
};

export function HeroOverlayCard({
    title,
    subtitle,
    iconSrc,
    iconAlt = '',
    className,
    style,
}: HeroOverlayCardProps) {
    return (
        <div
            className={clsx(
                'pointer-events-auto flex items-center justify-between rounded-xl bg-gray-50 p-3 shadow-[0px_0px_5px_0px_#00000017,2px_2px_7px_0px_#0000000D]',
                className,
            )}
            style={style}
        >
            <div className="flex min-w-0 flex-1 flex-col items-start justify-start gap-1 pr-2">
                <p className="text-sm font-medium text-gray-900">{title}</p>
                <p className="text-xs font-normal text-gray-450">{subtitle}</p>
            </div>
            <Image
                src={iconSrc}
                alt={iconAlt}
                width={20}
                height={20}
                className="h-5 w-5 shrink-0 object-contain object-center"
            />
        </div>
    );
}
